module.exports = __webpack_public_path__ + "static/media/membrete.984b38ca.png";